/**
 * An absent or non-boolean flag means indexable, in both cat-service-api (which defaults it in two
 * places server-side) and UPS (where a null means indexable because only `false` was migrated).
 */
export const defaultMetaRobotsIndexable = (value: unknown): boolean =>
  typeof value === 'boolean' ? value : true;
